import {
    IonButton,
    IonImg,
  } from "@ionic/react";

  import { ASSESSMENT_STATUSES } from "../../movenet/params";
  interface Props {
    setspaceVerification: Function;
  }
  
  const SpaceVerificationModal: React.FC<Props> = ({ setspaceVerification }) => {
    const ReDoCalibration=()=>{
      //localStorage.setItem('isCalibrated','0');
      //localStorage.setItem('Calibration_Complete','0');
      ASSESSMENT_STATUSES.IsCalibrated=false;
      //ASSESSMENT_STATUSES.Calibration_Completed=false;
      //localStorage.setItem('distance_calculated','0');
      //localStorage.setItem('_ankle_starting_point','0');
      // localStorage.setItem('space_calculated','0');
      //localStorage.setItem('GestureDetectionStart','0');
      ASSESSMENT_STATUSES.GestureDetectionStart=0;
      //localStorage.setItem('CalibrationState','0');

      //this.props.setspaceVerification(false);
      // localStorage.setItem('isCalibrated','0');
      setspaceVerification(false)
  
    };
    return (
      <>
        <div className="space-verification-wrapper">
          <h4>Do you have enough space <br></br> to complete this test? </h4>
          <p>You need about 15 ft. of space</p>
          <div className="btn-wrap-sec ">
           <IonButton className="redo-calibration-btn" onClick={() => ReDoCalibration()} placeholder={undefined}>No, recalibrate</IonButton>
           <IonButton className="generic-btn " onClick={() => setspaceVerification(false)} placeholder={undefined}>Yes, continue</IonButton>
          </div>
        </div>
      </>
    );
  };
  
  export default SpaceVerificationModal;
  